import React from "react";
import "./BotonEliminar.css";

export default function BotonEliminar({ id, onEliminar }) {
  return (
    <button
      className="boton-eliminar"
      onClick={() => onEliminar?.(id)}
    >
      Eliminar
    </button>
  );
}
